export const DEFAULT_MEMBER_GROUP_ID = 0;
